import styled from "styled-components";
import { Typography } from "antd";
import { Link } from "react-router-dom";
import ProjectTypes from "../../../enums/ProjectTypes";
import { Colors } from "../styled";

const { Text } = Typography;

export const ProjectLabel = styled(Text)<{ typeProjectColor?: ProjectTypes }>`
  color: ${({ typeProjectColor }) =>
    Colors[typeProjectColor || "default"]} !important;
  padding: 0 !important;
`;

export const LinkProject = styled(Link)`
  color: black;
  margin-bottom: 1em;
`;
